/* --- Fork of librairy made by justgoscha and licensed under MIT license --- */
import angular from 'angular'

/* @ngInject */
const myField = (
  utils,
  valueHandler,
  labels,
  types,
  optionsHandler,
  $compile,
) => {
  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      myOptions: '=',
      myDisabled: '=',
      enableValidator: '=?',
      fnBlur: '&?',
      fnFocus: '&?',
    },
    /* @ngInject */
    controller: ['$scope', function ($scope) {
      let set = false
      $scope.$watch('ngModel', (newValue, oldValue) => {
        if ($scope.validator && $scope.enableValidator && newValue && !set) {
          $scope.validator.oldValue = newValue
          set = true
        }
      })
    },],
    link: {
      pre: (scope, element, attrs, ngModel) => {
        const defaultOptions = {
          icon: '',
          label: '',
          ref: '',
          required: false,
          disabled: scope.myDisabled || false,
          type: types.text(),
          unique: false,
          messages: {
            required: labels.error.input.required,
            exists: labels.error.input.exists,
          },
        }

        const options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)

        scope.icon = options.icon
        scope.label = options.label
        scope.id = options.ref + utils.math.random()
        scope.ref = options.ref
        scope.required = scope.enableValidator ? options.required : false
        scope.disabled = options.disabled
        scope.type = options.type

        if (options.unique && scope.enableValidator) {
          scope.validator = {
            nature: options.nature,
            ref: options.ref,
            oldValue: scope.ngModel,
          }
        }

        scope.onBlur = () => {
          scope.isFocused = false
          if (scope.fnBlur) scope.fnBlur()
        }

        scope.onFocus = () => {
          scope.isFocused = true
          if (scope.fnFocus) scope.fnFocus()
        }

        let input = `<input id="{{id}}"
          name="{{id}}"
          class="main-input"
          type="{{type.nature}}"
          ng-model="ngModel"
          ng-required="required"
          ng-disabled="disabled"
          ng-pattern="type.pattern"
          ng-maxlength="{{type.maxlength}}"
          ng-minlength="{{type.minlength}}"
          validator="validator"
          ng-model-options="{ updateOn: 'default blur', debounce: {'default': 300, 'blur': 0} }"
          ng-focus="onFocus()"
          ng-blur="onBlur()"
          ng-input="onInput()"
          `
        if (valueHandler.isNotNull(options.type.mask)) {
          input += `ui-mask="${options.type.mask}"`
        }
        input += ' />'
        input += `<i class="close-input material-icons"
          ng-click="ngModel = null"
          ng-bind-html="$root.icons.close">
        </i>`

        const res = $(input).appendTo(element)
        $compile(res)(scope)

        scope.$watch('myDisabled', (newValue, oldValue) => {
          if (newValue !== oldValue && valueHandler.isNotNull(newValue)) {
            scope.disabled = scope.myDisabled
          }
        }, true)
      },
      post: (scope, element, attrs, ngModel) => {

      },
    },
    template: require('./myField.html'),
  }
}

export default myField



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myField.js